<template>
  <div id="app" ref="app">
    <loading v-if="$store.state.isLoadingActive"></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import i18n from "./i18n";
import loading from "@/components/reusable/Loading";
export default {
  name: "app",
  components: { loading },
  mounted() {
    // check if iOS and add class 'ios-touch' to resolve :hover problems on iOS
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
      this.$refs.app.classList.add("ios-touch");
    }
  },
  watch: {
    template(newVal) {
        if (newVal) {
          if(this.template.survey.iso3 && this.template.survey.iso3 === 'COL'){
            i18n.changeLanguage('es')
          }
        }
    }
  },
  computed: {
    template() {
      return this.$store.state.template;
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/style.scss";
</style>
